import buttonVariants, { type ButtonVariantProps } from '@discover-ui/button/variants';
import { cn } from '@discover-lib/utils';

export type DynamicDialogTriggerVariantProps = ButtonVariantProps;

export default function dynamicDialogTriggerVariants(props: DynamicDialogTriggerVariantProps = {}) {
  return cn(buttonVariants(props), cn('justify-between gap-1'));
}
